









import {defineComponent} from "@vue/composition-api";
import BlockMessage from "@base/Components/BlockMessage.vue";

export default defineComponent({
    components: {
        BlockMessage
    },
    props: {
        team_id: {
            type: String,
            required: true
        },
    }
});
